import { ShieldCheck, ShieldX, ShieldAlert } from 'lucide-react';

/**
 * Small per-row ZATCA reporting indicator. Reuses pos_orders.zatca.status:
 *   REPORTED / CLEARED → green  ·  FAILED → red  ·  PENDING → amber.
 * Renders nothing when a row has no ZATCA data (e.g. non-POS invoices), so
 * only e-invoiced rows are annotated.
 */
export function ZatcaRowIcon({ status, className = '' }) {
  const s = (status || '').toUpperCase();
  const map = {
    REPORTED: { c: 'text-emerald-600', Icon: ShieldCheck, t: 'Reported to ZATCA' },
    CLEARED: { c: 'text-emerald-600', Icon: ShieldCheck, t: 'Cleared by ZATCA' },
    FAILED: { c: 'text-rose-600', Icon: ShieldX, t: 'ZATCA reporting failed / rejected' },
    PENDING: { c: 'text-amber-500', Icon: ShieldAlert, t: 'ZATCA reporting pending' },
    HELD: { c: 'text-violet-600', Icon: ShieldAlert, t: 'Historical Invoice Reference — Pending Review (not submitted)' },
    UNKNOWN: { c: 'text-orange-600', Icon: ShieldAlert, t: 'ZATCA outcome unknown — chain blocked for review' },
    EXCLUDED_TEST: { c: 'text-muted-foreground', Icon: ShieldX, t: 'Test sale — excluded from ZATCA reporting' },
    NOT_SUBMITTED: { c: 'text-muted-foreground', Icon: ShieldAlert, t: 'Not submitted to ZATCA' },
  };
  const cfg = map[s];
  if (!cfg) return null;
  const { c, Icon, t } = cfg;
  return (
    <span
      title={`ZATCA: ${t}`}
      data-testid="zatca-row-icon"
      data-status={s}
      className={`inline-flex items-center ${className}`}
    >
      <Icon size={14} className={c} />
    </span>
  );
}

export default ZatcaRowIcon;
